import * as React from 'react';
import {TextareaHTMLAttributes} from 'react';

import {TabsContainer, Link} from './styled';

interface Props extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    baseUrl?: string;
    links?: {label: string; path: string}[];
}

export function TableTabs(props: Props) {
    const {links, baseUrl} = props;

    return (
        <TabsContainer>
            {links ? (
                links.map(({label, path}) => (
                    <Link key={path} to={`${baseUrl ?? ''}/${path}`}>
                        {label}
                    </Link>
                ))
            ) : (
                <div />
            )}
        </TabsContainer>
    );
}
